import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../api/supabase';

export const useUserProfile = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchUserProfile = async () => {
      if (!user?.id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const { data, error: profileError } = await supabase
          .from('profiles')
          .select('*, organizations(name)')
          .eq('id', user.id)
          .single();

        if (profileError) {
          console.error('Error fetching user profile:', profileError);
          setError(profileError);
          return;
        }

        if (isMounted) {
          setProfile({
            ...data,
            organization_name: data?.organizations?.name || null,
          });
        }
      } catch (err) {
        console.error('Error in fetchUserProfile:', err);
        if (isMounted) {
          setError(err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchUserProfile();

    return () => {
      isMounted = false;
    };
  }, [user?.id]);

  // Helper to check if user is admin
  const isAdmin = profile?.role === 'admin';

  return {
    profile,
    loading,
    error,
    isAdmin,
    role: profile?.role
  };
};